import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReviewOptions = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "reviewOptions",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12828",
			"data-name": "Path 12828",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12829",
			"data-name": "Path 12829",
			d: "M10,18v1a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H6",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12830",
			"data-name": "Path 12830",
			d: "M14.828,9.172a4,4,0,1,1-5.657,0,4,4,0,0,1,5.657,0",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12831",
			"data-name": "Path 12831",
			d: "M14.83,14.83,19,19",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12832",
			"data-name": "Path 12832",
			d: "M6,10H5A2,2,0,0,1,3,8V5A2,2,0,0,1,5,3H8a2,2,0,0,1,2,2V6",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12833",
			"data-name": "Path 12833",
			d: "M14,6V5a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2V8a2,2,0,0,1-2,2H18",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgReviewOptions;
